import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { HttpService } from 'src/app/service/http/http.service';

import { Config } from 'src/app/app-constant';


@Injectable({
  providedIn: 'root'
})
export class ElcmGenericServiceService {
  
  constructor(private httpService: HttpService, private config: Config) { }
  
  getAllAccessMatrix(loggedInUserCompanyID: any): Observable<any> {
    // Logged in Admin is fetch automatically by token
    const request = { 'companyId': loggedInUserCompanyID, 'search': null, 'loggedInUserRole': 'Admin' }
    return this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request);
  }
  
  empFilterForAllEmployeeList(allEmpList: any[], adminEmpListOrAdminId: any[] | number, idKey: string, filterByAdminId = false ): any | [] {
    // Filters from all employes As per admin accessed employes
    if(!filterByAdminId && Array.isArray(adminEmpListOrAdminId)){
      if(!(allEmpList?.length > 0 && adminEmpListOrAdminId?.length > 0)) return [];
      
      if(idKey === 'userId') return allEmpList.filter((emp: any) => this.getFilteredEmployees(emp?.userId, adminEmpListOrAdminId));
      if(idKey === 'id') return allEmpList.filter((emp: any) => this.getFilteredEmployees(emp?.id, adminEmpListOrAdminId));
      if(idKey === 'hrId') return allEmpList.filter((emp: any) => this.getFilteredEmployees(emp?.hrId, adminEmpListOrAdminId));
      
    } else {
      if(!(allEmpList?.length > 0 && (typeof adminEmpListOrAdminId === 'number'))) return [];
      
      if(idKey === 'hrId') return allEmpList.filter((emp: any) => emp?.hrId === adminEmpListOrAdminId);
      if(idKey === 'createdBy') return allEmpList.filter((emp: any) => emp?.createdBy === adminEmpListOrAdminId);
    }
  }
  
  getFilteredEmployees(compareId:any, adminAccessEmpList:any) {
    return adminAccessEmpList.some((admEmp: any) => compareId == admEmp?.employeeId)
  }
  
  getAdminDataForDashboard(loggedInUserCompanyID:any, selectedYear:any, loggedInCompanyFiscalyear:any){
    return forkJoin({
      allUserRecords: this.httpService.callGetService(`${this.config.employeeList}/${loggedInUserCompanyID}`),
      probationRecords: this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${loggedInUserCompanyID}&yearRange=${selectedYear}&fiscalType=${loggedInCompanyFiscalyear}`),
      probationExtend: this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${loggedInUserCompanyID}&year=${selectedYear}`),
      confirmedEmployees: this.httpService.callGetService(`${this.config.convertEmployeeList}?companyId=${loggedInUserCompanyID}&yearRange=${selectedYear}&fiscalType=${loggedInCompanyFiscalyear}`),
    })
  }
  
  filterDashboardData(loggedInUserId:any, selectedYear:any, allUserRecords:any, probationRecords:any, probationExtend:any, confirmedEmployees:any, adminAccessData:any){
    const allUserData = allUserRecords.data.filter( (userData:any) => userData.year == selectedYear );
    console.log('allUserData ------------------------- ', allUserData)
    const allAdminUserRecords = this.empFilterForAllEmployeeList(allUserData, Number(loggedInUserId), 'hrId', true);
    const usersRecordsLength = allAdminUserRecords.length;
    
    return {
      candidateCount: usersRecordsLength,
      hrFilledCount: this.getCountOfEmpStatus(allAdminUserRecords, 'FILLED_BY_HR'),
      offerLetterCount: this.getCountOfEmpStatus(allAdminUserRecords, 'OFFER_LETTER_SENT'),
      appointmentLetterCount: this.getCountOfEmpStatus(allAdminUserRecords, 'APPROVED_APPOINTMENT_LETTER'),
      filledCandidateCount: this.getCountOfEmpStatus(allAdminUserRecords, 'FILLED_BY_EMPLOYEE_PENDING_BY_HR'),
      adminProbationRecords: this.empFilterForAllEmployeeList(probationRecords?.data, adminAccessData?.employeeDetails, 'userId'),
      probationExtend: this.empFilterForAllEmployeeList(probationExtend?.data, adminAccessData?.employeeDetails, 'userId').filter((probEmp: any) => probEmp.probationStatus === 'Extension'),
      confirmationCount: this.empFilterForAllEmployeeList(confirmedEmployees?.data, Number(loggedInUserId), 'createdBy', true)
    }
  }
  
  getCountOfEmpStatus(empLis: any, empStatusValue:string){
    let count = 0;
    empLis.map( (emp:any) => { if(emp.status === empStatusValue) count++; });
    return count;
  }
  
}
